import React from 'react'
import FormattedMessage from '../../helpers/FormattedMessage'

import Standard from "../../assets/images/image-073.jpeg"
import Classic from "../../assets/images/image-068.jpeg"
import Universal from "../../assets/images/image-074.jpeg"
import Zip from "../../assets/images/image-079.jpeg"
import GrayHoodieGirl from "../../assets/images/modal_grayHoodieGirl.png"
import GrayHoodieBack from "../../assets/images/modal_grayHoodieBack.jpg"
import BrownHoodie from "../../assets/images/modal_brownHoodie.jpg"
import GrayHoodieZip from "../../assets/images/modal_grayHoodieZip.jpg"
import Tshirt from "../../assets/images/image-081.jpeg"
import SecondTshirt from "../../assets/images/image-084.jpg"
import Crewneck from "../../assets/images/image-087.jpeg"
import CrewneckBoy from "../../assets/images/image-086.jpg"
import Pants from "../../assets/images/image-090.jpg"
import SecondPants from "../../assets/images/image-088.jpeg"
import Bag from "../../assets/images/image-093.jpeg"
import SecondBag from "../../assets/images/image-092.jpg"
import ToteBag from "../../assets/images/image-094.jpeg"
import SecondToteBag from "../../assets/images/image-095.jpg"
import BucketHat from "../../assets/images/image-100.jpeg"
import BucketHatBack from "../../assets/images/image-099.jpg"

export const typeStaticContentBasic = (
  <>
  <div className="double-card">
      <img src={Classic} alt="classic Hoodie girl"/>
      <div className="cloth-type">
        <h3 className="big-title"><FormattedMessage id={"ModalTwo.blockOne.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockOne.subtitle"}/>
        </div>
        <p className="text-top-margin"><FormattedMessage id={"ModalTwo.blockOne.text"}/></p>
        <p className="sub-info"><FormattedMessage id={"ModalTwo.blockOne.textSecond"}/></p>
      </div>
    </div>
    <div className="double-card">
      <div className='position-bottom'>
        <h3 className="small-title"><FormattedMessage id={"ModalTwo.blockTwo.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockTwo.subTitle"}/>
        </div>
        <div className="second-title">
          <FormattedMessage id={"ModalTwo.blockTwo.secondSubTitle"}/>
        </div>
        <div className="colors-wrapper">
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#999' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockTwo.firstColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#000' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockTwo.secondColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: 'rgb(0, 23, 64)' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockTwo.thirdColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#FFF' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockTwo.fourColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: 'rgb(32, 96, 66)' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockTwo.sixthColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#840C0E' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockTwo.fifthColor"}/>
            </div>
          </div>
        </div>
      </div>
      <img src={GrayHoodieGirl} alt="Gray hoodie girl"/>
    </div>


    {/* <div className="double-card">
      <img src={Standard} alt="girl with hoodie"/>
      <div className="cloth-type">
        <h3 className="big-title"><FormattedMessage id={"ModalTwo.blockThree.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockThree.subtitle"}/>
        </div>
        <p className="text-top-margin"><FormattedMessage id={"ModalTwo.blockThree.text"}/></p>
        <p className="sub-info"><FormattedMessage id={"ModalTwo.blockThree.textSecond"}/></p>
      </div>
    </div>
    <div className="double-card">
      <div className='position-bottom'>
        <h3 className="small-title"><FormattedMessage id={"ModalTwo.blockFour.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockFour.subTitle"}/>
        </div>
        <div className="second-title">
         <FormattedMessage id={"ModalTwo.blockFour.secondSubTitle"}/>
        </div>
        <div className="colors-wrapper">
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#999' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockFour.firstColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#000' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockFour.secondColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: 'rgb(0, 23, 64)' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockFour.thirdColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#B2A7CB' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockFour.fourColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#B6D8B0' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockFour.fifthColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#98ACD6' }}/>
            </div>
            <div className="color-name">
             <FormattedMessage id={"ModalTwo.blockFour.sixthColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#C9688B' }}/>
            </div>
            <div className="color-name">
             <FormattedMessage id={"ModalTwo.blockFour.seventhColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#4979A8' }}/>
            </div>
            <div className="color-name">
             <FormattedMessage id={"ModalTwo.blockFour.eighthColor"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#392F24' }}/>
            </div>
            <div className="color-name">
             <FormattedMessage id={"ModalTwo.blockFour.ninthColor"}/>
            </div>
          </div>
        </div>
      </div>
      <img src={GrayHoodieBack} alt="Gray hoodie back"/>
    </div> */}

    {/* <div className="double-card">
      <img src={Universal} alt="white hoodie"/>
      <div className="cloth-type">
        <h3 className="big-title"><FormattedMessage id={"ModalTwo.blockFive.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockFive.subTitle"}/>
        </div>
        <p className="text-top-margin"><FormattedMessage id={"ModalTwo.blockFive.text"}/></p>
        <p className="sub-info"><FormattedMessage id={"ModalTwo.blockFive.textSecond"}/></p>
      </div>
    </div>
    <div className="double-card">
      <div className='position-bottom'>
        <h3 className="small-title"><FormattedMessage id={"ModalTwo.blockSix.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockSix.subTitle"}/>
        </div>
        <div className="second-title">
         <FormattedMessage id={"ModalTwo.blockFour.secondSubTitle"}/>
        </div>
        <div className="colors-wrapper">
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#B4B5B8' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockSix.color1"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#000' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockSix.color2"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#E8A36D' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockSix.color3"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#FFF' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockSix.color4"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#551623' }}/>
            </div>
            <div className="color-name">
             <FormattedMessage id={"ModalTwo.blockSix.color5"}/>
            </div>
          </div>
        </div>
      </div>
      <img src={BrownHoodie} alt="Brown Hoodie"/>
    </div> */}

    <div className="double-card">
      <img src={Zip} alt="Black hoodie zip"/>
      <div className="cloth-type">
        <h3 className="big-title"><FormattedMessage id={"ModalTwo.blockSeven.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockSeven.subTitle"}/>
        </div>
        <p className="text-top-margin"><FormattedMessage id={"ModalTwo.blockSeven.text"}/></p>
        <p className="sub-info"><FormattedMessage id={"ModalTwo.blockSeven.secondText"}/></p>
      </div>
    </div>
    <div className="double-card">
      <div className='position-bottom'>
        <h3 className="small-title"><FormattedMessage id={"ModalTwo.blockEight.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockEight.subTitle"}/>
        </div>
        <div className="second-title">
         <FormattedMessage id={"ModalTwo.blockEight.secondSubTitle"}/>
        </div>
        <div className="colors-wrapper">
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#999' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockEight.color1"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#000' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockEight.color2"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#1C2751' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockEight.color3"}/>
            </div>
          </div>
        </div>
      </div>
      <img src={GrayHoodieZip} alt="Gray hoodie zip"/>
    </div>

    <div className="double-card">
      <img src={Tshirt} alt="T-shirt"/>
      <div className="cloth-type">
        <h3 className="big-title"><FormattedMessage id={"ModalTwo.blockNine.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockNine.subTitle"}/>
        </div>
        <p className="text-top-margin"><FormattedMessage id={"ModalTwo.blockNine.text"}/></p>
        <p className="sub-info"><FormattedMessage id={ "ModalTwo.blockNine.secondText"}/></p>
      </div>
    </div>

    <div className="double-card">
      <div className='position-bottom'>
        <h3 className="small-title"><FormattedMessage id={"ModalTwo.sizesTitle"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockTen.subTitle"}/>
        </div>
        <div className="second-title">
         <FormattedMessage id={"ModalTwo.colorTitle"}/>
        </div>
        <div className="colors-wrapper">
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#999' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockEight.color1"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#000' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockEight.color2"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#1C2751' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockEight.color3"}/>
            </div>
          </div>
        </div>
      </div>
      <img src={SecondTshirt} alt="T shirt"/>
    </div>
  </>
)

export const typeStaticContentExtended = (
  <>
  <div className="double-card">
      <img src={Crewneck} alt="Crewneck"/>
      <div className="cloth-type">
        <h3 className="big-title"><FormattedMessage id={"ModalTwo.blockEleven.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockEleven.subTitle"}/>
        </div>
        <p className="text-top-margin"><FormattedMessage id={"ModalTwo.blockEleven.text"}/></p>
        <p className="sub-info"><FormattedMessage id={"ModalTwo.blockEleven.secondText"}/></p>
      </div>
    </div>
    <div className="double-card">
      <div className='position-bottom'>
        <h3 className="small-title"><FormattedMessage id={"ModalTwo.sizesTitle"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockTen.subTitle"}/>
        </div>
        <div className="second-title">
         <FormattedMessage id={"ModalTwo.colorTitle"}/>
        </div>
        <div className="colors-wrapper">
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#999' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockEight.color1"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#000' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockEight.color2"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#1C2751' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockEight.color3"}/>
            </div>
          </div>
        </div>
      </div>
      <img src={CrewneckBoy} alt="T shirt"/>
    </div>

    <div className="double-card">
      <img src={Pants} alt="Pants"/>
      <div className="cloth-type">
        <h3 className="big-title"><FormattedMessage id={"ModalTwo.blockTwelve.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockTwelve.subTitle"}/>
        </div>
        <p className="text-top-margin"><FormattedMessage id={"ModalTwo.blockTwelve.text"}/></p>
        <p className="sub-info"><FormattedMessage id={"ModalTwo.blockTwelve.secondText"}/></p>
      </div>
    </div>
    <div className="double-card">
      <div className='position-bottom'>
        <h3 className="small-title"><FormattedMessage id={"ModalTwo.sizesTitle"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockTen.subTitle"}/>
        </div>
        <div className="second-title">
         <FormattedMessage id={"ModalTwo.colorTitle"}/>
        </div>
        <div className="colors-wrapper">
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#999' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockEight.color1"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#000' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockEight.color2"}/>
            </div>
          </div>
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#1C2751' }}/>
            </div>
            <div className="color-name">
              <FormattedMessage id={"ModalTwo.blockEight.color3"}/>
            </div>
          </div>
        </div>
      </div>
      <img src={SecondPants} alt="SecondPants"/>
    </div>

    {/* <div className="double-card">
      <img src={ Bag} alt="Bag"/>
      <div className="cloth-type">
        <h3 className="big-title"><FormattedMessage id={"ModalTwo.blockThirteen.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockThirteen.subTitle"}/>
        </div>
        <p className="text-top-margin"><FormattedMessage id={"ModalTwo.blockThirteen.text"}/></p>
        <p className="sub-info"><FormattedMessage id={"ModalTwo.blockThirteen.secondText"}/></p>
      </div>
    </div>
    <div className="double-card">
      <div className='position-bottom'>
        <h3 className="small-title"><FormattedMessage id={"ModalTwo.sizesTitle"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockFourteen.subTitle"}/>
        </div>
        <div className="second-title">
         <FormattedMessage id={"ModalTwo.colorTitle"}/>
        </div>
        <div className="colors-wrapper">
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#000' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockEight.color2"}/>
            </div>
          </div>
        </div>
      </div>
      <img src={SecondBag} alt="SecondBag"/>
    </div> */}

    <div className="double-card">
      <img src={ToteBag} alt="ToteBag"/>
      <div className="cloth-type">
        <h3 className="big-title"><FormattedMessage id={"ModalTwo.blockFifteen.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockFifteen.subTitle"}/>
        </div>
        <p className="text-top-margin"><FormattedMessage id={"ModalTwo.blockFifteen.text"}/></p>
        <p className="sub-info"><FormattedMessage id={"ModalTwo.blockFifteen.secondText"}/></p>
      </div>
    </div>

    <div className="double-card">
      <div className='position-bottom'>
        <h3 className="small-title"><FormattedMessage id={"ModalTwo.sizesTitle"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockSixteen.subTitle"}/>
        </div>
        <div className="second-title">
         <FormattedMessage id={"ModalTwo.colorTitle"}/>
        </div>
        <div className="colors-wrapper">
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#FFF' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockSixteen.colorName"}/>
            </div>
          </div>
        </div>
      </div>
      <img src={SecondToteBag} alt="SecondToteBag"/>
    </div>

    {/* <div className="double-card">
      <img src={BucketHat} alt="BucketHat"/>
      <div className="cloth-type">
        <h3 className="big-title"><FormattedMessage id={"ModalTwo.blockSeventeen.title"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockSeventeen.subTitle"}/>
        </div>
        <p className="text-top-margin"><FormattedMessage id={"ModalTwo.blockSeventeen.text"}/></p>
        <p className="sub-info"><FormattedMessage id={"ModalTwo.blockSeventeen.secondText"}/></p>
      </div>
    </div>
    <div className="double-card">
      <div className='position-bottom'>
        <h3 className="small-title"><FormattedMessage id={"ModalTwo.sizesTitle"}/></h3>
        <div className="subtitle">
          <FormattedMessage id={"ModalTwo.blockEighteen.subTitle"}/>
        </div>
        <div className="second-title">
         <FormattedMessage id={"ModalTwo.colorTitle"}/>
        </div>
        <div className="colors-wrapper">
          <div className="color-wrapper">
            <div className="color">
              <div style={{ backgroundColor: '#000' }}/>
            </div>
            <div className="color-name">
               <FormattedMessage id={"ModalTwo.blockEighteen.colorName"}/>
            </div>
          </div>
        </div>
      </div>
      <img src={BucketHatBack} alt="BucketHatBack"/>
    </div> */}
    </>
)


export const typeStaticContent = (
  <div className="static-wrapper">
    {typeStaticContentBasic}
    {typeStaticContentExtended}
  </div>
)

export const typeStaticContentUnion = (
  <div className="static-wrapper">
    {typeStaticContentBasic}
  </div>
)